export enum BrandIconSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
  default = 'default',
}